import React, { useMemo, useState } from "react";
import "./Articles.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import arrowicon from "../../../../assets/icons/arrow.png";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import { useInsightsSection } from "../../../../context/InsightsPageContext";
import {
  getArticleFiltersFromSection,
  getArticlesFromSection,
} from "../../../../services/contentApi";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import { stripRichText } from "../../../../utils/richText";

const VIEW_ALL = "View all";

const Articles = () => {
  const { section, loading } = useInsightsSection("articles");
  const [activeFilter, setActiveFilter] = useState(VIEW_ALL);

  const articles = useMemo(
    () => (section?.fields ? getArticlesFromSection(section) : []),
    [section]
  );

  const apiFilters = useMemo(
    () => (section?.fields ? getArticleFiltersFromSection(section) : []),
    [section]
  );

  const filters = useMemo(() => {
    const list = [VIEW_ALL, ...apiFilters];
    return [...new Set(list)];
  }, [apiFilters]);

  const sortLabel = section?.fields?.sortLabel ?? "";

  const filteredArticles = useMemo(() => {
    if (activeFilter === VIEW_ALL) return articles;
    const activeLabel = stripRichText(activeFilter);
    return articles.filter(
      (a) => stripRichText(a.category) === activeLabel
    );
  }, [articles, activeFilter]);

  if (loading || !section?.fields) return null;

  return (
    <section className="articles">
      <div className="articles__container">
        <div className="articles__top">
          {filters.length > 1 ? (
            <div className="articles__filters">
              {filters.map((filter) => (
                <button
                  key={filter}
                  type="button"
                  className={`filter-btn ${
                    activeFilter === filter ? "active" : ""
                  }`}
                  onClick={() => setActiveFilter(filter)}
                >
                  <CmsText content={filter} as="span" />
                </button>
              ))}
            </div>
          ) : null}

          {sortLabel ? (
            <div className="articles__sort">
              <CmsText content={sortLabel} as="span" />{" "}
              <span>
                <IoIosArrowDown className="arrowdonwarticles" />
              </span>
            </div>
          ) : null}
        </div>

        {filteredArticles.length > 0 ? (
          <div className="articles__grid">
            {filteredArticles.map((item) => {
              const imageSrc = resolveMediaUrl(item.image);
              const avatarSrc = resolveMediaUrl(item.avatar);

              return (
                <Link
                  key={item.slug}
                  to={`/insights/${item.slug}`}
                  className="article-card"
                >
                  {imageSrc ? (
                    <div className="article-card__image">
                      <img src={imageSrc} alt={stripRichText(item.title)} />
                    </div>
                  ) : null}

                  <div className="article-card__content">
                    {item.category ? (
                      <CmsText
                        content={item.category}
                        as="span"
                        className="article-card__category"
                      />
                    ) : null}

                    <div className="article-card__title-row">
                      {item.title ? (
                        <CmsText content={item.title} as="h3" />
                      ) : null}
                      <span className="arrow">
                        <img src={arrowicon} alt="" />
                      </span>
                    </div>

                    {item.desc ? (
                      <RichTextContent
                        content={item.desc}
                        className="article-card__desc"
                      />
                    ) : null}

                    {item.author || avatarSrc ? (
                      <div className="article-card__author">
                        {avatarSrc ? (
                          <img src={avatarSrc} alt={stripRichText(item.author)} />
                        ) : null}
                        <div>
                          {item.author ? (
                            <CmsText content={item.author} as="h5" />
                          ) : null}
                          {item.date ? (
                            <CmsText content={item.date} as="span" />
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Link>
              );
            })}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Articles;
